import styled from 'styled-components'

export const PasswordModalContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;

  .link_whats {
    color: var(--brand-primary, #748351);
    margin-top: 16px;
    a {
      color: var(--brand-primary, #748351);
      text-decoration: underline;
    }
  }

  h1 {
    color: var(--brand-primary, #748351);
    margin-bottom: 2.5rem;
  }

  label {
    font-weight: 300;
    line-height: 1.6;
    text-align: center;
    margin-bottom: 0.5rem;
  }

  span {
    color: red;
    font-size: 0.9rem;
  }
`
